import {AbstractLayer, EditMode} from '../../core/layers/abstract.layer';
import {Point} from '../../core/point';
import {AbstractEditorPlugin} from './abstract-editor.plugin';
import {TextLayer} from '/src/core/layers/text.layer';

/**
 * Add layer plugin
 */
export class AddPlugin extends AbstractEditorPlugin {
    firstPoint: Point;
    captured: boolean = false;

    onMouseDown(point: Point, event: MouseEvent): void {
        const {state} = this.session.editor;
        const {layers} = this.session.state;
        if (!state.activeTool || state.activeLayer) {
            return;
        }
        if (layers.find((l) => l.isEditing())) {
            return;
        } else {
            this.captured = true;
            layers.forEach((l) => (l.selected = false));
            state.activeLayer = state.activeTool.createLayer();
            state.activeLayer.color = this.session.editor.lastColor;
            this.session.addLayer(state.activeLayer as AbstractLayer);
            state.activeLayer.startEdit(EditMode.CREATING, point);
            state.activeTool.onStartEdit(state.activeLayer as AbstractLayer, point, event);
            this.session.virtualScreen.redraw(false);
        }
    }

    onMouseMove(point: Point, event: MouseEvent): void {
        if (this.captured) {
            const {activeLayer} = this.session.editor.state;
            if (!activeLayer) return;
            activeLayer.edit(point, event);
            this.session.virtualScreen.redraw(false);
        }
    }

    /**
     * Handles mouse up events after layer creation.
     *
     * For text layers specifically:
     * - Completes the layer creation process
     * - Automatically triggers text editing mode via triggerTextEdit()
     * - This allows users to immediately start typing after creating a text layer
     * - Works in conjunction with Inspector component's reactive text editing system
     */
    onMouseUp(point: Point, event: MouseEvent): void {
        if (this.captured) {
            const {activeLayer, activeTool} = this.session.editor.state;
            this.captured = false;
            if (!activeLayer) return;
            activeLayer.stopEdit();
            activeTool.onStopEdit(activeLayer as AbstractLayer, point, event);
            activeLayer.selected = true;
            this.session.virtualScreen.redraw();

            // Trigger text editing mode for newly created text layers
            if (activeLayer instanceof TextLayer) {
                this.session.editor.triggerTextEdit();
            }
        }
    }
}
